import { render, staticRenderFns } from "./report_problema.vue?vue&type=template&id=35c463b6&"
import script from "./report_problema.vue?vue&type=script&lang=js&"
export * from "./report_problema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports